<template>
    <form v-if="dataCytoSpecLN && IDLABSelected">
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >
          <div class="modal-card">

                <header class="modal-card-head"  >
                    <section class="modal-card-body  "  >
                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>


                        <HeaderDecorate :showLabNo=true :idlab="IDLABSelected.idlab" v-if="IDLABSelected" />
                    </section>
                </header>

                <section class="modal-card-body"  >

                    <DetailUsedPartFromRequestDataEachLab
                            :IDLABSelected ="IDLABSelected"/>

                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-5"> Status </p>
                            </div>
                            <div class="level-item">
                            </div>
                            <div class="level-item">
                                <p v-if="dataCytoSpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataCytoSpecLN.status.name }}  </p>
                                <p v-if="dataCytoSpecLN.status.id >=5 && dataCytoSpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataCytoSpecLN.status.name }}  </p>
                                <p v-if="dataCytoSpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataCytoSpecLN.status.name }} </p>
                            </div>
                            <div class="level-item">
                                <b-icon icon="lock" type="is-danger"  v-if="dataCytoSpecLN.status.id >=5 "  ></b-icon>
                                <b-icon icon="lock-open" type="is-success"  v-if="dataCytoSpecLN.status.id < 5 "  ></b-icon>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5"> Assigned for </p>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5 has-text-grey"> &nbsp; {{ dataCytoSpecLN.assigned_to_user.name }}</p>
                            </div>
                            <div class="level-item" v-if="userIsAdmin && dataCytoSpecLN.status.id !== 7 ">
                                <b-button size="is-medium"
                                          icon-left="minus-circle" @click="disableLab" >
                                    Disable
                                </b-button>
                            </div>
                            <div class="level-item">

                            </div>
                        </div>



                    </nav>

                    <!--*************************************************************************-->
<!--                    <nav class="level">-->
<!--                        <h1 class="title" style="color: #167df0">-->
<!--                            <b-icon  icon="file-document"  size="is-small"></b-icon>-->
<!--                            {{HeaderInfoPrepare}}-->
<!--                        </h1>-->
<!--                        <div class="level-item">-->
<!--                            <button class="button is-danger">Button</button>-->
<!--                        </div>-->
<!--                    </nav>-->

                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                            <h1 class="title" style="color: #167df0">
                                <b-icon  icon="file-document"  size="is-small"></b-icon>
                                {{headerInfoPrepare}}
                            </h1>
                            </div>
<!--                            <div class="level-item">-->
<!--                                <b-button type="is-danger"   icon-right="plus" @click="showPlusEditor">Plus</b-button>-->
<!--                            </div>-->

                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <p class="is-size-6 has-text-grey"> My Templates </p>
                            </div>
                            <div class="level-item">

                                <b-select placeholder="Template" v-model="dataTemplateSelectedPrepare"
                                          :disabled="!(userRoleFind(3) &&dataCytoSpecLN.status.id <5)">
                                    <option
                                            v-for="dataTemplate in dataTemplates"
                                            :value="dataTemplate.id"
                                            :key="dataTemplate.id">
                                        {{ dataTemplate.title }}
                                    </option>
                                </b-select>


                            </div>
                            <div class="level-item">
                                <b-button type="is-success"
                                          icon-right="plus"
                                          @click="addTemplate('editorDat_prepare')"
                                          :disabled="!(userRoleFind(3) &&dataCytoSpecLN.status.id <5)"/>
                            </div>
                        </div>
                    </nav>

                    <hr>
                    <!--                    <vue-editor v-model="dataCytoSpecLN.dat_prepare.dat"-->
                    <!--                                id="editorDat_prepare"-->
                    <!--                                :editor-toolbar="customToolbar"-->
                    <!--                                :disabled="!userRoleFind(4) || (dataAllContent.status.id === 5 || dataAllContent.status.id === 6 ) "-->
                    <!--                                 />-->

                    <vue-editor v-model="dataCytoSpecLN.dat_prepare.dat"
                                id="editorDat_prepare"
                                :editor-toolbar="customToolbar"
                                :disabled="!(userRoleFind(3)&&dataCytoSpecLN.status.id <5 )"
                                ref="editorDat_prepare"
                    />
                    <br>
<!--  headerInfoPrepare  plus   -->
                    <div  v-if="dataCytoSpecLN && dataCytoSpecLN.data_plus.dat_prepare.length>0"   >

                        <div v-for="dat_prepare_plus in  dataCytoSpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="headerPrepareInfoPlus"
                                       :plus=true />
                            <div class="box"  >
                                <div v-html="dat_prepare_plus.dat" ></div>
                            </div>
                            <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                         :date_rec="dat_prepare_plus.date_rec"
                                         :time_rec="dat_prepare_plus.time_rec"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "dat_prepare_plus.id.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                         :labKind = "IDLABSelected.kind"
                                         />

                        </div>
                    </div>
                    <br>
                    <!--*************************************************************************-->
<!--                    <nav class="level">-->
<!--                        <h1 class="title" style="color: #167df0">-->
<!--                            <b-icon  icon="file-document"  size="is-small"></b-icon>-->
<!--                            Finding and Content-->
<!--                        </h1>-->
<!--                    </nav>-->

                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <h1 class="title" style="color: #167df0">
                                    <b-icon  icon="file-document"  size="is-small"></b-icon>
                                    Finding and Content
                                </h1>
                            </div>

                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <p class="is-size-6 has-text-grey"> My Templates </p>
                            </div>
                            <div class="level-item">

                                <b-select placeholder="Template" v-model="dataTemplateSelectedCt"  :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id)">
                                    <option
                                            v-for="dataTemplate in dataTemplates"
                                            :value="dataTemplate.id"
                                            :key="dataTemplate.id">
                                        {{ dataTemplate.title }}
                                    </option>
                                </b-select>


                            </div>
                            <div class="level-item">
                                <b-button type="is-success"
                                          icon-right="plus"
                                          @click="addTemplate('editorDat_ct')"
                                          :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id)"/>
                            </div>
                        </div>
                    </nav>



                    <hr>
                    <vue-editor v-model="dataCtModel"
                                id="editorDat_ct"
                                :editor-toolbar="customToolbar"
                                :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id)"
                                ref="editorDat_ct"
                    />


                    <br>
<!--              content plus      -->
                    <div   v-if="dataCytoSpecLN && dataCytoSpecLN.data_plus.dat_ct.length>0" >
                        <div v-for="dat_content_plus in  dataCytoSpecLN.data_plus.dat_ct" :key="dat_content_plus.id">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="findingAndContentPlus"
                                       :plus=true />
                            <div class="box"  >
                                <div v-html="dat_content_plus.dat" ></div>
                            </div>
                            <FooterPlus  :user_rec="dat_content_plus.user_rec"
                                         :date_rec="dat_content_plus.date_rec"
                                         :time_rec="dat_content_plus.time_rec"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "dat_content_plus.id.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                         :labKind = "IDLABSelected.kind"
                                         />
                        </div>
                    </div>
                    <hr>
                    <!--*************************************************************************-->
                    <nav class="level">
                        <h1 class="title" style="color: #167df0">
                            <b-icon  icon="file-document"  size="is-small"></b-icon>
                            Add Images
                        </h1>
                    </nav>
                    <nav class="level">
                        <b-tooltip label="Attach Image"  position="is-right">
                            <b-button
                                    icon-right="paperclip"
                                    type="is-success"
                                    @click="addImageAttach"
                                    :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id)">Add Images</b-button>
                        </b-tooltip>
                    </nav>
                    <hr>
                    <ThumbnailImageList  :modeThumbnailImageList="modeThumbnailImageList" v-if="dataCytoSpecLN.img.dat.length>0"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         @deleteImage="deleteImage" />
                    <hr  v-if="dataCytoSpecLN.img.dat.length>0">
                    <br>
<!--   images plus  -->
                    <div   v-if="dataCytoSpecLN && dataCytoSpecLN.data_plus.img.length>0" >
                        <div v-for=" img in dataCytoSpecLN.data_plus.img" :key="img.idtime">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="ImagePlus"
                                       :plus=true />
                            <br>
                            <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="false"  />
                            <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                         :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                         :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "img.idtime.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                         :labKind = "IDLABSelected.kind"
                                         />
                            <br>
                        </div>
                    </div>


                    <!--*************************************************************************-->

                    <nav class="level">
                        <h1 class="title" style="color: #167df0"> <b-icon
                                icon="codepen"
                                size="is-small">
                        </b-icon>  Classification of Diseases</h1>
                    </nav>
                    <nav class="level">
                        <b-tooltip label="Add More Disease Code"  position="is-right">
                            <b-button
                                    type="is-success"
                                    icon-right="plus"
                                    @click="addNewDiseaseCode"
                                    :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id)"
                            />

                        </b-tooltip>
                    </nav>
                    <br>

                    <b-table
                            :data="isEmpty ? [] : dataCytoSpecLN.diag_code.dat"
                            bordered
                            striped
                            narrowed
                            hoverable
                            focusable
                            mobile-cards>


                            <b-table-column   label="Chapter" v-slot="props">
                                {{ props.row.level1Name }}
                            </b-table-column>
                            <b-table-column   label="Body System" v-slot="props">
                                {{ props.row.level2Name }}
                            </b-table-column>
                            <b-table-column   label="Organ/Tissue" v-slot="props">
                                {{ props.row.level3Name }}
                            </b-table-column>
                            <b-table-column   label="Character/Subcategories" v-slot="props">
                                {{ props.row.level4Name }}
                            </b-table-column>
                            <b-table-column   label="Extensions" v-slot="props">
                                {{ props.row.level5Name }}
                            </b-table-column>
                            <b-table-column   label="%" v-slot="props">
                                {{ props.row.labDiseasecodeAccurateName }}
                            </b-table-column>

                            <b-table-column   label="Unclassified Descriptions" v-slot="props">
                                {{ props.row.unClassifiedCodes }}
                            </b-table-column>


                            <b-table-column   label="Remark" v-slot="props">
                                {{ props.row.comment }}
                            </b-table-column>





                            <b-table-column   label="#" v-slot="props">
                                <b-button type="is-danger" icon-right="delete" @click="deleteLabDiseasecodeRecWithLabID(props.row.ID)" :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id)" />
                            </b-table-column>



                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>

<!--  diag plus    -->
                    <div  v-for="diag_code_plus in dataCytoSpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">

                        <TitlePlus
                                :datUserWhoView="getNameAndSurname"
                                :titleDisplay="ClassificationOfDiseases"
                                :plus=true
                        />
                        <b-table         :data="diag_code_plus.dat"
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                        >
                            <b-table-column   label="Chapter" v-slot="props">
                                {{ props.row.level1Name }}
                            </b-table-column>
                            <b-table-column   label="Body System" v-slot="props">
                                {{ props.row.level2Name }}
                            </b-table-column>
                            <b-table-column   label="Organ/Tissue" v-slot="props">
                                {{ props.row.level3Name }}
                            </b-table-column>
                            <b-table-column   label="Character/Subcategories" v-slot="props">
                                {{ props.row.level4Name }}
                            </b-table-column>
                            <b-table-column   label="Extensions" v-slot="props">
                                {{ props.row.level5Name }}
                            </b-table-column>
                            <b-table-column  label="Unclassified Descriptions" v-slot="props">
                                {{ props.row.unClassifiedCodes }}
                            </b-table-column>
                            <b-table-column  label="%" v-slot="props">
                                {{ props.row.labDiseasecodeAccurateName }}
                            </b-table-column>
                            <b-table-column  label="Remark" v-slot="props">
                                {{ props.row.comment }}
                            </b-table-column>

                        </b-table>

                        <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                     :date_rec="diag_code_plus.dat[0].date_rec"
                                     :time_rec="diag_code_plus.dat[0].time_rec"
                                     :userIsAdmin="userIsAdmin"
                                     :idToDelete = "diag_code_plus.idtime.toString()"
                                     :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                     :labKind = "IDLABSelected.kind"
                                     />
                    </div>
                </section>

                <footer class="modal-card-foot">
                    <div class="container" style=" width: 100vw; margin-left: 10px;">

                        <nav class="level" style="width:100vw;">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-button type="is-danger"
                                              icon-left="close"  @click="closeModal"   >
                                        Close
                                    </b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-warning" icon-left="cloud-upload"   v-if="userRoleFind(3)&& dataCytoSpecLN.status.id <5"   @click="updateData(3)"  > Save Prepare</b-button>
                                </div>
                                <div class="level-item">
<!--                                    (userRoleFind(4)||userRoleFind(5) )  ?????  -->
                                    <b-button type="is-success" icon-left="cloud-upload"   v-if="(userRoleFind(4) )&&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id "    @click="updateData(4)"  > Save Content to Draft</b-button>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"      v-if="(userRoleFind(4) ) &&dataCytoSpecLN.status.id <5 && dataCytoSpecLN.assigned_to_user.id === user_id "   @click="updateData(5)"  > Save Content to Publish Incomplete</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"     v-if="(userRoleFind(4) ) &&dataCytoSpecLN.status.id <6 && dataCytoSpecLN.assigned_to_user.id === user_id "   @click="updateData(6)"  > Save Content to Publish Complete</b-button>
                                </div>

                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                            </div>
                        </nav>
                    </div>
                </footer>

          </div>
        </b-modal>
     <UploadFiles v-if="isModalUploadFiles"
                  :idlab=null
                  :plus=false
                  @close="closeAddImageAttach"
                  @closeWithData="closeAddImageAttachWithData"/>
     <SelectDiseaseCode v-if="isModalSelectDiseaseCode"
                        @close="closeSelectDiseaseCode"
                        @closeWithChange="closeSelectDiseaseCode_WithChange" />
     <DisableDlg   v-if="isDisableDlg"
                   ref="DisableDlg"
                   @close="closeDisableDlg"
                   @closeWithChange="closeDisableDlgWithChange"  />
<!--     <PlusEditor   v-if="isPlusEditor"-->
<!--                   :isShowing="isPlusEditor"-->
<!--                   :idlab="IDLABSelected.idlab"-->
<!--                   :submitTypePlusEdit="submitTypePlusEditTmp"-->
<!--                   @close="closePlusEditor"-->
<!--                   @closeWithChange="closePlusEditorWithChange" />-->
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios";
    import {getMyTemplate ,
            getBaseURLAvartar ,
            getBaseURLforBackEnd ,
            getConfigAxios   ,
            LOCATE_ENDPOINT_UPDATEEACH_KINDLAB ,
            LOCATE_ENDPOINT_VIEWEACH_KINDLAB ,
            genUUID ,
            DATACYTOSPECLN_MODEL }  from '@/utils.js'
    import {mapState} from "vuex";

    import SelectDiseaseCode from "./SelectDiseaseCode";
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import globalconst from "../../mixins/globalconst";
    import UploadFiles from "../UtilsComponents/UploadFiles";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import { VueEditor } from "vue2-editor"
    import htmlToText from "html-to-text";
    import DisableDlg from "./DisableDlg";
    import HeaderDecorate from "./DecorateComponents/HeaderDecorate";
    import TitlePlus from "./Plus/TitlePlus";
    import FooterPlus from "./Plus/FooterPlus";
    import DetailUsedPartFromRequestDataEachLab from "../UtilsComponents/DetailUsedPartFromRequestDataEachLab";


    export default {
        name: "EditDocLABTxtKind" ,
        components:{
            VueEditor,
            SelectDiseaseCode,
            UploadFiles,
            ThumbnailImageList,
            DisableDlg,
            HeaderDecorate,
            // PlusEditor
            TitlePlus,
            FooterPlus,
            DetailUsedPartFromRequestDataEachLab
        },
        mixins:[globalconst,userRoleFind],
        mounted() {

        },
        computed:{
            ...mapState({
                OPDSelected : state => state.opd_target.opd_selected,
                user_id : state => state.master_data.user_id,
                userIsAdmin : state => state.master_data.userIsAdmin,
                clientIP : state => state.master_data.clientIP,
                user_role : state => state.master_data.user_role,
                access_token: state => state.master_data.access_token,
            }) ,


            // Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8')

            dataCtModel:{
                get: function () {
                    // console.log('raw data')
                    // console.log(this.dataCytoSpecLN.dat_ct.dat)
                    // console.log( Buffer.from(this.dataCytoSpecLN.dat_ct.dat, 'base64').toString('utf-8') )
                    // return Buffer.from(this.dataCytoSpecLN.dat_ct.dat, 'base64').toString('utf-8')
                    return this.dataCytoSpecLN.dat_ct.dat
                },
                set: function (newValue) {
                    this.dataCytoSpecLN.dat_ct.dat = newValue
                }
            },

            getNameAndSurname: function(){
                // return 'test'
                const userFullName = localStorage.getItem('user_name_surname')
                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px"> View by ${userFullName}
                          ${this.dataCytoSpecLN.current_date}
                          ${this.dataCytoSpecLN.current_time} </p>`
                // return localStorage.getItem('user_name_surname')
            },
            getTextFromPrepareHTML:function () {
                return  htmlToText.fromString(this.dataCytoSpecLN.dat_prepare.dat, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            getTextFromContentHTML:function () {
                return  htmlToText.fromString( this.dataCytoSpecLN.dat_ct.dat, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            lock3 : function() {
                return   this.userRoleFind(3) && (this.dataCytoSpecLN.status.id >= 5)
            },
            lock4 : function() {
                return  this.userRoleFind(4) && (this.dataCytoSpecLN.status.id >= 5)
            },
            getHTMLParse(){
                return  JSON.parse(JSON.stringify(this.dataAllContent.dat))
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                return this.dataCytoSpecLN.img.dat.map(dat => {
                    return   { id: genUUID(5) ,
                               file : null,
                               urlTempUploaded:
                                   dat.fresh ? `${getBaseURLAvartar()}/temp/${dat.file}` :   `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                               title : dat.title,
                               fileNameUploaded: dat.file,
                               fresh : false  }

                })
            }
        },
        props:{
            IDLABSelected: null
        },
        methods:{
            // closePlusEditorWithChange(){
            //     this.isPlusEditor = false
            // },
            // closePlusEditor(){
            //     this.isPlusEditor = false
            // },
            // showPlusEditor(){
            //     this.submitTypePlusEditTmp =  SUBMIT_TYPE_PLUS_EDIT.prepare
            //     this.isPlusEditor = true
            // },

            dataPassThruImageListPlus(_idtime) {
                if(this.dataCytoSpecLN.data_plus.img.length>0) {
                    const member = this.dataCytoSpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            },
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataCytoSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataCytoSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataCytoSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },

            //**********************************************************************************************************

            closeDisableDlgWithChange(){
                this.isDisableDlg = false
                this.dataCytoSpecLN.status.id = 7
                this.dataCytoSpecLN.status.name = "Disabled"
            },
            closeDisableDlg(){
                this.isDisableDlg = false
            },
            disableLab(){
                this.isDisableDlg = true
            },
         
            addTemplate(editorTarget){





                   if(editorTarget === "editorDat_ct"){

                       if(this.dataTemplateSelectedCt !== null) {
                           const datToEditor = this.dataTemplates.find(member => member.id === this.dataTemplateSelectedCt)

                           this.$refs.editorDat_ct.quill.focus()
                           if (this.$refs.editorDat_ct.quill.getSelection().index !== null) {
                               this.$refs.editorDat_ct.quill.clipboard.dangerouslyPasteHTML(this.$refs.editorDat_ct.quill.getSelection().index, datToEditor.content_html);
                               this.$refs.editorDat_ct.quill.setSelection(this.$refs.editorDat_ct.quill.getSelection().index + datToEditor.content_txt.length)
                           }
                       }else{
                           this.$buefy.dialog.alert({
                               title: 'Error',
                               message: `please select some template`,
                               type: 'is-danger',
                               hasIcon: true,
                               icon: 'times-circle',
                               iconPack: 'fa',
                               ariaRole: 'alertdialog',
                               ariaModal: true
                           })
                       }
                   }






                    if(editorTarget === "editorDat_prepare"){

                        if(this.dataTemplateSelectedPrepare!== null) {
                            const datToEditor = this.dataTemplates.find(member => member.id === this.dataTemplateSelectedPrepare)
                            this.$refs.editorDat_prepare.quill.focus()
                            if(this.$refs.editorDat_prepare.quill.getSelection().index !== null) {
                                this.$refs.editorDat_prepare.quill.clipboard.dangerouslyPasteHTML(this.$refs.editorDat_prepare.quill.getSelection().index,  datToEditor.content_html);
                                this.$refs.editorDat_prepare.quill.setSelection(  this.$refs.editorDat_prepare.quill.getSelection().index + datToEditor.content_txt.length )
                            }
                        }else{
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `please select some template`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                        }

                    }





            },
            loadData(){

                const datTo = {
                    "ln": this.IDLABSelected.idlab,
                    "ip": this.clientIP
                }
                const vm = this
                this.isFullScreenSearching = true

                if((this.IDLABSelected.kind).toUpperCase() === "CYTOLOGY") {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.CYTOLOGY}`,datTo,getConfigAxios())
                        .then(res=>{
                            vm.dataCytoSpecLN = res.data
                            // transform base64 into normal string
                            vm.dataCytoSpecLN.dat_prepare.dat = Buffer.from(vm.dataCytoSpecLN.dat_prepare.dat, 'base64').toString('utf-8')
                            vm.dataCytoSpecLN.dat_ct.dat = Buffer.from(vm.dataCytoSpecLN.dat_ct.dat, 'base64').toString('utf-8')



                            vm.isFullScreenSearching = false


                        })
                        .catch(err=>{
                            console.log(err)

                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                        })
                }
            },
            deleteImage(fileNameUploaded){
                 // console.log(fileNameUploaded)
                 // console.log(this.dataCytoSpecLN.img.dat.find( m )
                 const member = this.dataCytoSpecLN.img.dat.find(member => member.file === fileNameUploaded  )
                 const memberIndex = this.dataCytoSpecLN.img.dat.indexOf(member)
                 this.dataCytoSpecLN.img.dat.splice(memberIndex,1)

            },
            addImageAttach(){
                this.isModalUploadFiles = true
            },
            closeAddImageAttach(){
                this.isModalUploadFiles = false
            },
            closeAddImageAttachWithData(dat){

                if(dat.file){

                    const tmp = {
                            "file":   dat.fileNameUploaded,
                            "title":  dat.title,
                            "fresh": true
                    }
                    this.dataCytoSpecLN.img.dat.push(tmp)
                }

                this.isModalUploadFiles = false
            },
            deleteLabDiseasecodeRecWithLabID(id){
                  // console.log(id)
                const member = this.dataCytoSpecLN.diag_code.dat.find( member => member.ID === id)
                const memberIndex = this.dataCytoSpecLN.diag_code.dat.indexOf(member)
                // console.log(memberIndex)
                this.dataCytoSpecLN.diag_code.dat.splice(memberIndex,1)
                // console.log(this.labDiseasecodeRecWithLabID)
            },
            closeSelectDiseaseCode_WithChange(dataToSave){
                // console.log(JSON.stringify(dataToSave))
                this.dataCytoSpecLN.diag_code.dat.push(dataToSave)
                // console.log(this.labDiseasecodeRecWithLabID)
            },
            closeSelectDiseaseCode(){
                this.isModalSelectDiseaseCode = false
            },
            addNewDiseaseCode(){
                this.isModalSelectDiseaseCode = true
            },

            getMyTemplateLocal(){
                getMyTemplate(this.user_id)
                .then(res=>{
                    // console.log('load my template')
                    // console.log(res)
                    this.dataTemplates = res.data
                })
                .catch(err=>{
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `${err}`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })

            },

            closeModal(){
                this.isComponentModalActive = false
                this.$emit('close')
            },



            updateData(idstatus){
                if (this.isSavingCytology || (this.IDLABSelected.kind || '').toUpperCase() !== 'CYTOLOGY') return

                // console.log(this.dataCytoSpecLN)

              //  // update ICD10 Code
               var arrIndex = []
               var arrID_GRP_ICD10 = []
               var arrID_ACCURATE = []
               var arrUnclassifiedCode = []
               var arrCommentTxt  = []
              //  clear null to empty string
                for(var j =0;j<this.dataCytoSpecLN.diag_code.dat.length;j++) {

                    if (this.dataCytoSpecLN.diag_code.dat[j].level5ID === null)  {
                        this.dataCytoSpecLN.diag_code.dat[j].level5ID = ""
                    }
                    if (this.dataCytoSpecLN.diag_code.dat[j].level4ID === null)  {
                        this.dataCytoSpecLN.diag_code.dat[j].level4ID = ""
                    }
                    if (this.dataCytoSpecLN.diag_code.dat[j].level3ID === null)  {
                        this.dataCytoSpecLN.diag_code.dat[j].level3ID = ""
                    }
                    if (this.dataCytoSpecLN.diag_code.dat[j].level2ID === null )  {
                        this.dataCytoSpecLN.diag_code.dat[j].level2ID = ""
                    }
                    if (this.dataCytoSpecLN.diag_code.dat[j].level1ID === null ) {
                        this.dataCytoSpecLN.diag_code.dat[j].level1ID = ""
                    }


                }


              // console.log(this.dataCytoSpecLN.diag_code.dat)
              for(var i =0;i<this.dataCytoSpecLN.diag_code.dat.length;i++) {

                  if (this.dataCytoSpecLN.diag_code.dat[i].level5ID !== "") {
                      arrID_GRP_ICD10.push( this.dataCytoSpecLN.diag_code.dat[i].level5ID)
                  } else if (this.dataCytoSpecLN.diag_code.dat[i].level4ID !== "")  {
                      arrID_GRP_ICD10.push( this.dataCytoSpecLN.diag_code.dat[i].level4ID)
                  } else if (this.dataCytoSpecLN.diag_code.dat[i].level3ID !== "")  {
                      arrID_GRP_ICD10.push( this.dataCytoSpecLN.diag_code.dat[i].level3ID)
                  } else if (this.dataCytoSpecLN.diag_code.dat[i].level2ID !== "")  {
                      arrID_GRP_ICD10.push( this.dataCytoSpecLN.diag_code.dat[i].level2ID)
                  } else if (this.dataCytoSpecLN.diag_code.dat[i].level1ID !== "") {
                      arrID_GRP_ICD10.push( this.dataCytoSpecLN.diag_code.dat[i].level1ID)
                  }else {
                      arrID_GRP_ICD10.push(null)
                  }


                  arrIndex.push(this.dataCytoSpecLN.diag_code.dat[i].ID)
                  arrID_ACCURATE.push(this.dataCytoSpecLN.diag_code.dat[i].labDiseasecodeAccurateID)
                  arrUnclassifiedCode.push(this.dataCytoSpecLN.diag_code.dat[i].unClassifiedCodes)
                  arrCommentTxt.push(this.dataCytoSpecLN.diag_code.dat[i].comment)
              }


                // console.log(JSON.stringify(this.dataCytoSpecLN))
               var arrImage = []
                for(var k = 0;k<this.dataCytoSpecLN.img.dat.length;k++) {
                    arrImage.push({"file": this.dataCytoSpecLN.img.dat[k].file , "title":this.dataCytoSpecLN.img.dat[k].title ,"fresh": this.dataCytoSpecLN.img.dat[k].fresh })
                }

                // ***************************
                //  update code/main cytology
                // ***************************
                const vm = this
                const datTo = {
                    "ln": this.IDLABSelected.idlab,
                    "ip": this.clientIP ,
                    "status" : idstatus,
                    "data": {
                        "dat_prepare": this.dataCytoSpecLN.dat_prepare.dat,
                        "dat_prepare_txt": this.getTextFromPrepareHTML,
                        "ct_dat_html" : this.dataCytoSpecLN.dat_ct.dat,
                        // "ct_dat_html" : Buffer.from(this.dataCytoSpecLN.dat_ct.dat).toString('base64') ,
                        "ct_dat_html_txt" : this.getTextFromContentHTML,
                        "lab_diseasecode_labid" :{
                                                    "arrindex" : arrIndex,
                                                    "arrid_grp_icd10": arrID_GRP_ICD10,
                                                    "arrid_accurate": arrID_ACCURATE,
                                                    "arrunclassifiedcode":arrUnclassifiedCode,
                                                    "arrcommenttxt": arrCommentTxt
                                                 },
                        "lab_img_path":arrImage
                    }
                }


                 // console.log('Cyto')
                 // console.log(JSON.stringify(datTo))


                this.isSavingCytology = true
                this.isFullScreenSearching = true
                if((this.IDLABSelected.kind).toUpperCase() === "CYTOLOGY") {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_UPDATEEACH_KINDLAB.CYTOLOGY}`,datTo,getConfigAxios())
                        .then((res)=>{
                            const savedText = res.data && res.data.saved_text
                            if (savedText) {
                                // Preserve edits made after this request was submitted.
                                if (Object.prototype.hasOwnProperty.call(savedText, 'dat_prepare') &&
                                    vm.dataCytoSpecLN.dat_prepare.dat === datTo.data.dat_prepare) {
                                    vm.dataCytoSpecLN.dat_prepare.dat = savedText.dat_prepare
                                }
                                if (Object.prototype.hasOwnProperty.call(savedText, 'ct_dat_html') &&
                                    vm.dataCytoSpecLN.dat_ct.dat === datTo.data.ct_dat_html) {
                                    vm.dataCytoSpecLN.dat_ct.dat = savedText.ct_dat_html
                                }
                            }
                            vm.dataCytoSpecLN.status.id = idstatus
                            const warnings = res.data && res.data.warnings
                            const hasWarnings = Array.isArray(warnings) && warnings.length > 0
                            const reference = (res.data && res.data.request_id) || ''
                            vm.$buefy.toast.open({
                                message: hasWarnings
                                    ? `บันทึกสำเร็จ แต่มีงานหลังบันทึกที่ต้องตรวจสอบ (รหัสอ้างอิง: ${reference})`
                                    : 'Update data completely!',
                                type: hasWarnings ? 'is-warning' : 'is-success'
                            })
                        })
                        .catch(err=>{
                            const result = (err.response && err.response.data) || {}
                            const messages = {
                                invalid_input: 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาตรวจสอบช่องที่ระบุ',
                                unsupported_characters: 'มีอักขระที่ฐานข้อมูลไม่รองรับ กรุณาตรวจสอบช่องที่ระบุ',
                                image_missing: 'ไม่พบไฟล์รูปชั่วคราว กรุณาอัปโหลดรูปใหม่',
                                image_conflict: 'ชื่อไฟล์รูปซ้ำกับไฟล์เดิมที่มีเนื้อหาต่างกัน กรุณาอัปโหลดใหม่',
                                status_conflict: 'ข้อมูลสถานะผลตรวจไม่สอดคล้อง กรุณาเปิดผลตรวจใหม่',
                                not_found: 'ไม่พบรายการตรวจ cytology นี้',
                                save_outcome_unknown: 'ยังยืนยันผลการบันทึกไม่ได้ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ',
                                save_failed: 'บันทึกไม่สำเร็จ กรุณาแจ้งรหัสอ้างอิงให้ผู้ดูแลตรวจสอบ'
                            }
                            const message = messages[result.code] || (err.response
                                ? 'บันทึกไม่สำเร็จ กรุณาตรวจสอบการเข้าสู่ระบบหรือแจ้งผู้ดูแล'
                                : 'ไม่ได้รับคำตอบจากระบบ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ')
                            // Buefy renders dialog messages as HTML; escape server fields.
                            const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({
                                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
                            }[char]))
                            const characters = Array.isArray(result.unsupported_characters)
                                ? result.unsupported_characters.slice(0, 12)
                                    .map(item => `${item.character} (${item.codepoint})`).join(', ')
                                : ''
                            const characterHint = characters ? ` อักขระที่ไม่รองรับ: ${characters}` : ''
                            const field = result.field ? ` ช่อง: ${result.field}` : ''
                            const reference = result.request_id ? ` รหัสอ้างอิง: ${result.request_id}` : ''
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: escapeHtml(message + field + characterHint + reference),
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })


                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                            vm.isSavingCytology = false
                        })
                }
            },













        },
        data(){
            return {
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                ],
                //  dataPrePareToAdd : {
                //     // condition ? exprIfTrue : exprIfFalse
                //     'level1ID': this.level1Selected ? this.level1Selected.id : '',
                //     'level1Name': this.level1Selected ? this.level1Selected.name : '' ,
                //     'level2ID': this.level2Selected ? this.level2Selected.id : '',
                //     'level2Name': this.level2Selected ? this.level2Selected.name : '' ,
                //     'level3ID': this.level3Selected ?  this.level3Selected.id : '',
                //     'level3Name': this.level3Selected ? this.level3Selected.name :'',
                //     'level4ID': this.level4Selected ? this.level4Selected.id : '',
                //     'level4Name': this.level4Selected ? this.level4Selected.name : '',
                //     'level5ID': this.level5Selected ? this.level5Selected.id : '',
                //     'level5Name':this.level5Selected ? this.level5Selected.name : '',
                //     'labDiseasecodeAccurateID': this.diseasecodeAccurateSelected ? this.diseasecodeAccurateSelected.id : '',
                //     'labDiseasecodeAccurateName':this.diseasecodeAccurateSelected ? this.diseasecodeAccurateSelected.name :'',
                //     'comment' : this.commentTxt
                // },


                // [{"ID":"8939077578","level1ID":"EZ2BX2ZD7X9QWELM","level1Name":"Inflammation","level2ID":"FF084BE0776A1099AF03","level2Name":"TEST","level3ID":null,"level3Name":null,"level4ID":null,"level4Name":null,"level5ID":null,"level5Name":null,"labDiseasecodeAccurateID":null,"labDiseasecodeAccurateName":null,"unClassifiedCodes":null,"comment":null},
                //  {"ID":"6160866119","level1ID":"J88XP2ASM4F3CZRE","level1Name":"Neoplasia","level2ID":"EDB84AC62BA013DF09BF","level2Name":"test2","level3ID":"CD02356E62180D97255A","level3Name":"456456","level4ID":null,"level4Name":null,"level5ID":null,"level5Name":null,"labDiseasecodeAccurateID":null,"labDiseasecodeAccurateName":null,"unClassifiedCodes":null,"comment":null}]

                labDiseasecodeRecWithLabID: [
                    // { 'ID': '' ,'level1ID': null, 'level1Name': '','level2ID': null, 'level2Name': '','level3ID': null, 'level3Name': '', 'level4ID': null, 'level4Name': '', 'level5ID': null, 'level5Name': '','labDiseasecodeAccurateID': 1, 'labDiseasecodeAccurateName': null, 'unClassifiedCodes' : null  , 'comment' : null}
                ] ,
                isModalSelectDiseaseCode : false,
                isModalUploadFiles : false,
                dataTemplateSelectedCt : null,
                dataTemplateSelectedPrepare : null,
                dataTemplates: null,
                isComponentModalActive : false,
                isFullScreen : true ,
                isFullScreenSearching : false,
                isSavingCytology: false,
                activeTab : 0,
                dataAllContent : {
                    "dat": "",
                    "dat_prepare": "",
                    "status": "",
                    "status_id": -1,
                    "assigned_to_user" : -1
                },

                isEmpty : false,
                modeThumbnailImageList : "edit",
                modeUploadFile : "edit",
                dataCytoSpecLN :DATACYTOSPECLN_MODEL ,

                isDisableDlg : false,

                // isPlusEditor : false,
                // submitTypePlusEditTmp : "",





            }
        },
        watch:{
            'dataCytoSpecLN.status.id' : function (val) {
                    if(val === 5){
                        this.modeThumbnailImageList = 'view'
                    }
            },
            plusSomethingSelected :{
                immediate : true,
                handler : function (val) {
                    if(val !== null){
                        this.hasErrorPlusSomethingSelected = false
                    }
                }
            },
        }

    }
</script>

<style scoped>
    .rows{
        display: flex;
        flex-direction: column;
    }
</style>